import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { ReturnStatement } from '@angular/compiler/src/output/output_ast';

@Directive({
  selector: '[NumberOnly]'
})
export class NumberOnlyDirective {

  @Input() OnlyNumber: boolean;

  constructor(private readonly el: ElementRef) { }

    @HostListener('keypress', ['$event']) onKeyDown(event) {
      const e = <KeyboardEvent> event;
      const ch = String.fromCharCode(e.keyCode);
      const transformedInput = ch.replace(/[^0-9]/g, '');

      if ('!@#$%^&*()´`'.indexOf(e.key) !== -1) {
        e.preventDefault();
      }

      if (this.el.nativeElement.value.indexOf('\'"¨~^´`')) {
        this.el.nativeElement.value = this.el.nativeElement.value.replace(/[\'"¨~^´`]/g, '');
      }

      if (transformedInput !== '' || [46, 8, 9, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105].indexOf(e.keyCode) !== -1) {
        return;
      } else {
        e.preventDefault();
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/directive/number-only.directive.ts